import React from 'react';
import VersionInfo from '../../config/version.json';
import Typography from '@material-ui/core/Typography';
import { versionNumberStyles } from '../../css/style';

const styles = versionNumberStyles();

const VersionAndBuildNumber = (props) => {
  return (
    <div style={props.containerStyle || styles.versionNumberContainer}>
      <Typography style={styles.appVersionAndBuildNumber}>{`Version: ${VersionInfo.version} Build: ${VersionInfo.build}`}</Typography>
    </div>
  );
};

VersionAndBuildNumber.displayName = 'VersionAndBuildNumber';

export default VersionAndBuildNumber;
